import { render, staticRenderFns } from "./yjkz.vue?vue&type=template&id=6d7f3c30&scoped=true"
import script from "./yjkz.vue?vue&type=script&lang=js"
export * from "./yjkz.vue?vue&type=script&lang=js"
import style0 from "./yjkz.vue?vue&type=style&index=0&id=6d7f3c30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7f3c30",
  null
  
)

export default component.exports